module.exports = __webpack_public_path__ + "static/media/fb-full.49195bac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/fb-full.svg
// module id = 760
// module chunks = 0